import { PESSOA_TIPO } from '@investirapri/financa.js/lib/enums';
import { createHybridSliderScale } from '../../../utils/sliderScales';
import { EMPRESAS_SORT_GROUPS, EMPRESAS_SORT_OPTIONS } from './empresasSortOptions';

export const EMPRESAS_FILTER_CONTROL = {
  MULTI_SELECT: 'multiSelect',
  NUMERIC: 'numeric'
};

const wStringParam = { type: 'string' };
const wNumberParam = { type: 'number' };
const wNonNegativeNumberParam = { ...wNumberParam, minimum: 0 };
const wCurrencySliderMaximum = 100000000000;
const wCurrencySliderLinearMaximum = 1000000000;
const wCurrencySliderValueStep = 1000000;
const wCurrencySliderScale = createHybridSliderScale({
  maximum: wCurrencySliderMaximum,
  linearMaximum: wCurrencySliderLinearMaximum,
  valueStep: wCurrencySliderValueStep,
  logPositions: 400
});

const wIgnoredPessoaTipoIds = [
  PESSOA_TIPO.FIS.id, // Pessoa Física
  PESSOA_TIPO.OUT.id, // Outros
  PESSOA_TIPO.AI.id, // Acessor
  PESSOA_TIPO.EST.id, // Estrangeira
  PESSOA_TIPO.BAL.id // Balanço
];

/** Monta as classificações permitidas no filtro de Empresas. */
function pvGetPessoaTipoOptions() {
  return Object.entries(PESSOA_TIPO)
    .filter(([, pTipo]) => !wIgnoredPessoaTipoIds.includes(pTipo.id))
    .sort(([, pFirst], [, pSecond]) => pFirst.descricao.localeCompare(pSecond.descricao, 'pt-BR'))
    .map(([pKey, pTipo]) => ({
      id: pKey,
      label: pTipo.descricao,
      value: pTipo.id
    }));
}

const wPessoaTipoOptions = pvGetPessoaTipoOptions();
const wEmpresasFields = [
  {
    name: 'pessoa_tipo_id',
    label: 'Tipo de empresa',
    helperText:
      'Ao selecionar mais de uma opção, serão exibidas somente empresas que possuam todos os tipos selecionados.',
    control: EMPRESAS_FILTER_CONTROL.MULTI_SELECT,
    options: wPessoaTipoOptions,
    query: {
      type: 'bitmask',
      values: wPessoaTipoOptions.map(pOption => pOption.value)
    }
  },
  {
    name: 'pl',
    label: 'Patrimônio líquido',
    control: EMPRESAS_FILTER_CONTROL.NUMERIC,
    direction: 'min',
    minimum: 0,
    maximum: wCurrencySliderMaximum,
    step: wCurrencySliderValueStep,
    showSlider: true,
    sliderScale: wCurrencySliderScale,
    currency: 'BRL',
    query: wNonNegativeNumberParam
  },
  {
    name: 'cs',
    label: 'Capital social',
    control: EMPRESAS_FILTER_CONTROL.NUMERIC,
    direction: 'min',
    minimum: 0,
    maximum: wCurrencySliderMaximum,
    step: wCurrencySliderValueStep,
    showSlider: true,
    sliderScale: wCurrencySliderScale,
    currency: 'BRL',
    query: wNonNegativeNumberParam
  }
];
const wQueryParams = wEmpresasFields.reduce(
  (pParams, pField) => ({ ...pParams, [pField.name]: pField.query }),
  {
    pesquisa: wStringParam,
    sort: {
      type: 'enum',
      values: EMPRESAS_SORT_OPTIONS.map(pOption => pOption.value).filter(Boolean)
    }
  }
);

const wEmpresasFilterConfig = {
  sortOptions: EMPRESAS_SORT_OPTIONS,
  sortGroups: EMPRESAS_SORT_GROUPS,
  fields: wEmpresasFields,
  queryParams: wQueryParams,
  requestParams: {
    page: wNumberParam,
    size: wNumberParam,
    cancelado: wStringParam,
    ...wQueryParams
  }
};

/** Retorna o contrato dos filtros disponíveis na listagem por setor. */
export function getEmpresasFilterConfig() {
  return wEmpresasFilterConfig;
}
